module.exports = __webpack_public_path__ + "img/Powering_the_Business_With_Resilience.f0756abc.jpg";